import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../helpers/Common';
import { REDUCER_NAME, downloadTopNewLow } from './reducer';
import ExportBlob from '../../../common/export-blob';
import Const from '../Const';

class ExportCommon extends React.Component {
  handleExport = () => {
    const { filter, downloadTopNewLow, typeTab, timeRange } = this.props;
    if (typeTab === 5) return;
    const apiParams = {
      ComGroupCode: filter,
      TimeRange: timeRange,
      Screen: Const.screen[typeTab],
    };
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopNewLow'),
    })}`;

    downloadTopNewLow(apiParams, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    timeRange: state[REDUCER_NAME].timeRange,
  };
};

const mapDispatchToProps = {
  downloadTopNewLow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
